import React from "react";
import CookieConsent from "react-cookie-consent";
import PopupBanner from "../Assets/img/popup-banner.svg";

const CookieNotice = () => {
  return (
    <>
      <div className="popup">
        {/* Basic */}
        {/* <CookieConsent>
        This website uses cookies to enhance the user experience.
      </CookieConsent> */}

        {/* option */}
        <CookieConsent
          disableStyles
          location="none"
          buttonText="Akzeptieren"
          cookieName="myAwesomeCookieName2"
          overlay
          overlayClasses="overlayclass"
          expires={150}
        >
          <div className="modal-content ">
            <div className="modal-header border-0">
              <div className="popup-modal-head-img">
                <img src={PopupBanner} alt="#" />
              </div>
            </div>
            <div className="modal-body">
              <div className="popup-modal-main-conetent">
                <h3 className="popup-modal-cont-title">
                  ISP Digital Offers a Free Course for New Users
                </h3>
                <div className="popup-modal-btn">
                  <a href="offer-details.html" className="theme-btn">
                    Learn more
                  </a>
                </div>
              </div>
            </div>
          </div>
        </CookieConsent>
      </div>
    </>
  );
};

export default CookieNotice;
